module.exports = __webpack_public_path__ + "static/media/uBack_Indigo_TM.50582575.png";